import type { PickerItemData } from "@design-system/Picker/Picker.types";

export type ArchiveFilter = "active" | "archived" | "all";

export const archiveFilterLabel: Record<ArchiveFilter, string> = {
    active: "Active",
    archived: "Archived",
    all: "All",
};

export const ARCHIVE_FILTER_ITEMS: Array<PickerItemData<ArchiveFilter>> = [
    { value: "active", label: archiveFilterLabel.active },
    { value: "archived", label: archiveFilterLabel.archived },
    { value: "all", label: archiveFilterLabel.all },
];

export const matchesArchiveFilter = ({
    isArchived,
    archiveFilter = "active",
}: {
    isArchived: boolean;
    archiveFilter?: ArchiveFilter;
}) => {
    if (archiveFilter === "all") {
        return true;
    }
    return archiveFilter === "archived" ? isArchived : !isArchived;
};
